import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { danger, success } from 'redux-store/reducers/common-reducer';
import { currentAccountUpdated } from '../../access/reducers/account';

import { API, patch } from 'utils/api';
import { t } from 'utils/language';

const { NEW_USERS } = API.END_POINTS.API;

export function saveUserSettings(id, data) {
  const url = `${NEW_USERS}/${id}`;

  return (dispatch) => {
    dispatch(showLoading(url));

    return patch(url, { data })
      .then((response) => {
        const account = response.data;

        dispatch(currentAccountUpdated(account));
        dispatch(hideLoading(url));
        dispatch(success(t('my_settings_save_success_message'),
          { keepBetweenPages: true }
        ));
      })
      .catch((error) => {
        dispatch(danger(error.response ? t('my_settings_save_error_message') : error.message));
        dispatch(hideLoading(url));
      });
  };
}
